export enum ProcessTypeEnum {
  // ProcessType for offer.
  ACQUISITION = 'ACQUISITION',
  RETENTION = 'RETENTION',
  MNP = 'MNP',
  UPSELL = 'UPSELL',
  PREPAID_2_POSTPAID = 'PREPAID_TO_POSTPAID', // Migration
  OTHER_SALES = 'DEVICE_ONLY',
  // ProcessType for whole cart.
  CART_ACQUISITION_FAMILY = 'CART_FAMILY',
  CART_BOHO = 'CART_BOHO',
}

